import * as types from './mutation-types'
import {getDefaultState} from './state'

export default {
  [types.SET_GUEST] (state, payload) {
    state.guest = payload
  },
  [types.SET_VERIFIED] (state, payload) {    
    state.verified = payload
  },
  [types.SET_TOKEN] (state, payload) {
    state.token = payload
  },
  [types.SET_WAITING_CODE] (state, payload) {
    state.waitingCode = payload
  },
  [types.SET_WAITING_RESET_CODE] (state, payload) {
    state.waitingResetCode = payload
  },
  [types.SET_CODE_ERROR] (state, payload) {
    state.codeError = payload
  },
  [types.SET_HAS_PASSWORD] (state, payload) {
    state.hasPassword = payload
  },
  [types.RESET_STATE] (state) {
    Object.assign(state, getDefaultState());
  }
}

